<template>
    <div>
        <div>
            {{ __('Convites') }}
        </div>

        <div>
            {{ __('Mensagens') }}
        </div>
    </div>
</template>

<script>
export default {
    props: ['user'],
}
</script>